import axios from '@/libs/http'

/**
 * 获取订单列表
 * */
export const getOrderList = (no, keyword, pageNo, pageSize) => {
    let data = new URLSearchParams()
    if(keyword != null && keyword != ''){
        data.append("keyword", keyword)
    }
    if(no != null && no != ''){
        data.append("no", no)
    }
    data.append("pageNo", pageNo)
    data.append("pageSize", pageSize)
    return axios.request({
        url: '/s/kf/clerkOrder/list',
        data,
        method: 'post'
    })
}

/**
 * 获取订单详情
 */
export const getOrder = (id) => {
    return axios.request({
        url: '/s/kf/clerkOrder/get',
        params: {
            id
        },
        method: 'get'
    })
}

/**
 * 完成订单
 */
export const finishedOrder = (id) => {
    return axios.request({
        url: '/s/kf/clerkOrder/finished',
        params: {
            id
        },
        method: 'get'
    })
}
